import api from "./axios";
import type {
  RankingsResult,
  RankingMetric,
  RankingScope,
  RankingSortBy,
  CamperRanksResponse,
  CenturyClubResponse,
} from "../types";

export interface RankingsQuery {
  metric: RankingMetric;
  scope: RankingScope;
  asOfDate?: string;
  termId?: number;
  divisionId?: number;
  team?: "army" | "navy";
  cabinId?: number;
  sortBy?: RankingSortBy;
  limit?: number;
}

function buildParams(q: RankingsQuery): Record<string, unknown> {
  const out: Record<string, unknown> = { metric: q.metric, scope: q.scope };
  if (q.asOfDate) out.asOfDate = q.asOfDate;
  if (q.termId != null) out.termId = q.termId;
  if (q.divisionId != null) out.divisionId = q.divisionId;
  if (q.team) out.team = q.team;
  if (q.cabinId != null) out.cabinId = q.cabinId;
  if (q.sortBy) out.sortBy = q.sortBy;
  if (q.limit != null) out.limit = q.limit;
  return out;
}

export const rankingsApi = {
  list: async (q: RankingsQuery): Promise<RankingsResult> => {
    const res = await api.get<RankingsResult>("/rankings", { params: buildParams(q) });
    return res.data;
  },

  exportCsv: async (q: RankingsQuery): Promise<Blob> => {
    const res = await api.get<Blob>("/rankings/export.csv", {
      params: buildParams(q),
      responseType: "blob",
    });
    return res.data;
  },

  camperRanks: async (camperId: number, termId?: number | null): Promise<CamperRanksResponse> => {
    const res = await api.get<CamperRanksResponse>(`/rankings/camper/${camperId}`, {
      params: termId != null ? { termId } : undefined,
    });
    return res.data;
  },

  centuryClub: async (): Promise<CenturyClubResponse> => {
    const res = await api.get<CenturyClubResponse>("/rankings/century-club");
    return res.data;
  },
};
